import { MAPS } from '@/maps'
import { useAppStore } from '@/hud-bridge/store'
import { formatTime, getBest } from '@/persistence/records'

export function MapSelectScreen() {
  const mode = useAppStore((s) => s.mode)
  const mapId = useAppStore((s) => s.mapId)
  const setMapId = useAppStore((s) => s.setMapId)
  const setScreen = useAppStore((s) => s.setScreen)
  const hideBriefing = useAppStore((s) => s.settings.hideBriefing)

  return (
    <div className="screen">
      <div className="menu-enter" style={{ marginTop: '8vh', maxWidth: 560, width: '100%' }}>
        <h1 className="h1">Карта</h1>
        <p className="muted">Handcrafted геометрия, процедурная раскладка мин.</p>

        <div className="list">
          {MAPS.map((m) => {
            const best = getBest(m.id, mode)
            const selected = mapId === m.id
            return (
              <button
                key={m.id}
                type="button"
                className={`map-option${selected ? ' selected' : ''}`}
                onClick={() => setMapId(m.id)}
              >
                <span>
                  <strong>{m.displayName}</strong>
                  <div className="muted">{m.description}</div>
                </span>
                <span className="muted" style={{ fontFamily: 'var(--font-mono)' }}>
                  {best ? formatTime(best.bestMs) : '—'}
                </span>
              </button>
            )
          })}
        </div>

        <div className="btn-row">
          <button
            type="button"
            className="btn btn-primary"
            disabled={!mapId}
            onClick={() => setScreen(hideBriefing ? 'loading' : 'briefing')}
          >
            {hideBriefing ? 'Старт' : 'Далее'}
          </button>
          <button type="button" className="btn btn-ghost" onClick={() => setScreen('mode')}>
            Назад
          </button>
        </div>
      </div>
    </div>
  )
}
